export interface PasswordFieldProps {
  name: string;
  placeholder?: string;
  className?: string;
  validate?: (value: any) => string | Promise<void> | undefined;
}

export const enum MASK_TYPE {
  PASSWORD = 'password',
  TEXT = 'text',
}
